/**
 * @param {number} index 
 */
export const getItemStyle = index => {
  return `item-${index + 1}`
}